/* v2 (2026-08-07): batida-no-emoji — REWRITE.

   Blocks emoji + pictographic characters in the personalization text fields:
     #batida-napis-text                               — Napis na torcie (cake inscription, 30 char)
     textarea[name="properties[_Message-Wiadomosc]"]  — Napisz swój list cross-product card (letter, 500 char)
     .batida-zw-textarea                              — Standalone 'Sheet' / 'Napisz swój list' product page
                                                        NOTE: uses properties[Message-Wiadomosc] (no underscore) —
                                                        DIFFERENT FoodSoft key; both keys stay as-is.
     #bp_text                                         — Pipeline's underlying mirror of Napis

   WHY v2 (the v1 bug — order #32426, "Dla mojej Aluni ❤️", 2026-08-04):
   v1 attached listeners per field and stamped the field with the HTML attribute
   data-batida-no-emoji="1" so it wouldn't wire twice. The Personalizacja card
   (v29, custom.js) rebuilds the PDP and REPLACES the inscription input with a
   copy. A copied node keeps its ATTRIBUTES but loses its EVENT LISTENERS — so
   the copy carried the "already wired" stamp while having no blocking code, and
   wireInput() skipped it forever. Both inscription fields were silently dead
   from 2026-05-22 to 2026-08-07. See issue #19.

   v2 strategy — nothing is stored on the element, so nothing can go stale:
   1. DELEGATED listeners on `document` (capture phase). Survives any number of
      DOM rebuilds, clones or re-injections. No wiring, no stamps, no observers.
   2. `beforeinput` — preventDefault when the inserted data contains emoji
      (blocks typing + paste at the source).
   3. `input` — safety net: strip anything that got through (drag-drop, autofill,
      IME composition, programmatic mirroring from custom.js / napis-atc-sync).
   4. Localized inline note under the field so the customer knows WHY the
      character vanished (PL/EN/DE/FR/UK, from a local map — deliberately NOT
      locales/*.json, which is at the Shopify translation cap / uk.json gap).
   5. Final sweep on any click / form submit — last line of defence before the
      value can reach the cart.

   Polish diacritics (ł ą ż ć ó ś ń ź ę), accented Latin, Cyrillic, punctuation
   and numbers all pass through unchanged. FoodSoft property keys are NEVER
   touched.

   NOTE: this is the browser layer only. A customer with JS disabled, or any
   non-storefront order path (draft orders, admin edits), can still put an emoji
   on the order. The hard guarantee lives in the FoodSoft middleware, which
   strips these same two properties before the order reaches the POS/printer. */
(function () {
  "use strict";
  if (window.__batidaNoEmojiLoaded) return;
  window.__batidaNoEmojiLoaded = true;

  var SELECTOR = '#batida-napis-text, textarea[name="properties[_Message-Wiadomosc]"], .batida-zw-textarea, #bp_text';

  /* ---------- emoji detection ---------- */
  /* Extended_Pictographic covers emoji + pictographs (smileys, hearts, food,
     flags, symbols, dingbats). FE0F = variation selector, 200D = ZWJ, 20E3 =
     keycap, so multi-codepoint sequences (families, skin tones, ❤️) go completely. */
  var EMOJI_RE;
  try {
    EMOJI_RE = new RegExp('[\\p{Extended_Pictographic}\\u{FE0F}\\u{200D}\\u{20E3}]', 'gu');
  } catch (e) {
    /* Fallback for browsers without Unicode property escapes. Less precise. */
    EMOJI_RE = /[‼⁉™ℹ↔-↪⌚-⌛⌨⏏⏩-⏳⏸-⏺Ⓜ▪-▫▶◀◻-◾☀-➿⤴-⤵⬅-⬇⬛-⬜⭐⭕〰〽㊗㊙️‍⃣]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|\uD83E[\uDD00-\uDFFF]/g;
  }

  function hasEmoji(s) {
    if (!s) return false;
    EMOJI_RE.lastIndex = 0;
    return EMOJI_RE.test(s);
  }

  function stripEmoji(s) {
    if (!s) return s;
    EMOJI_RE.lastIndex = 0;
    return String(s).replace(EMOJI_RE, '');
  }

  function isTarget(el) {
    return !!(el && el.matches && el.matches(SELECTOR));
  }

  /* ---------- localized note ---------- */
  var NOTE = {
    pl: 'Nie możemy wypisać emoji — użyj liter, cyfr i znaków.',
    en: "We can't write emoji — please use letters, numbers and symbols.",
    de: 'Emojis können wir nicht schreiben — bitte Buchstaben und Zahlen verwenden.',
    fr: "Nous ne pouvons pas écrire d'emoji — utilisez des lettres et des chiffres.",
    uk: 'Ми не можемо написати емодзі — використовуй літери та цифри.'
  };

  function locale() {
    var l = '';
    try { l = (window.Shopify && window.Shopify.locale) || ''; } catch (e) {}
    if (!l) l = (document.documentElement.getAttribute('lang') || '');
    l = String(l).slice(0, 2).toLowerCase();
    return NOTE[l] ? l : 'pl';
  }

  function noteText() {
    /* Prefer the i18n bridge if the key ever gets added; fall back to the map. */
    var fb = NOTE[locale()];
    try {
      if (typeof window.batidaT === 'function') return window.batidaT('no_emoji.notice', fb);
    } catch (e) {}
    return fb;
  }

  var STYLE_ID = 'batida-no-emoji-style';
  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var st = document.createElement('style');
    st.id = STYLE_ID;
    st.textContent =
      '.batida-no-emoji-note{margin:6px 0 0;font-family:"Lato",sans-serif;font-size:12.5px;line-height:1.4;' +
      'color:#1F4054;opacity:0;transition:opacity .18s ease;}' +
      '.batida-no-emoji-note.is-visible{opacity:1;}';
    document.head.appendChild(st);
  }

  var noteTimer = null;
  function showNote(el) {
    injectStyle();
    var host = el.parentNode;
    if (!host) return;
    var note = null;
    var kids = host.children;
    for (var i = 0; i < kids.length; i++) {
      if (kids[i].className === 'batida-no-emoji-note') { note = kids[i]; break; }
    }
    if (!note) {
      note = document.createElement('p');
      note.className = 'batida-no-emoji-note';
      note.setAttribute('role', 'status');
      host.insertBefore(note, el.nextSibling);
    }
    note.textContent = noteText();
    /* force a reflow so the fade replays on repeated attempts */
    void note.offsetWidth;
    note.classList.add('is-visible');
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () {
      note.classList.remove('is-visible');
    }, 4000);
  }

  /* ---------- 1. block at the source ---------- */
  document.addEventListener('beforeinput', function (e) {
    var el = e.target;
    if (!isTarget(el)) return;
    if (e.data && hasEmoji(e.data)) {
      e.preventDefault();
      e.stopPropagation();
      showNote(el);
    }
  }, true);

  /* ---------- 2. safety net ---------- */
  document.addEventListener('input', function (e) {
    var el = e.target;
    if (!isTarget(el)) return;
    if (typeof el.value !== 'string' || !hasEmoji(el.value)) return;
    var cleaned = stripEmoji(el.value);
    var atEnd = (el.selectionStart === el.value.length);
    el.value = cleaned;
    if (atEnd) {
      try { el.setSelectionRange(cleaned.length, cleaned.length); } catch (err) {}
    }
    showNote(el);
  }, true);

  /* ---------- 3. final sweep before anything can reach the cart ---------- */
  function sweep() {
    var els = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (typeof el.value === 'string' && hasEmoji(el.value)) el.value = stripEmoji(el.value);
    }
  }
  document.addEventListener('submit', sweep, true);
  document.addEventListener('click', sweep, true);

  /* Initial pass — covers fields pre-filled by cart resync / back button. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sweep);
  } else {
    sweep();
  }
  [100, 400, 1200].forEach(function (ms) { setTimeout(sweep, ms); });
})();
